import request from "@/utils/request";
import Qs from "qs";

// 综合态势
// 五常-综合态势-园区信息配置-编辑
export function wcParkInfoEdit(data) {
  return request({
    url: "/wuchang/zhts_parkinfo_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-综合态势-园区信息配置-详情
export function wcParkInfoDetail(data) {
  return request({
    url: "/wuchang/zhts_parkinfo_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-综合态势-能耗概括-新增
export function wcZhEnergyAdd(data) {
  return request({
    url: "/wuchang/zhts_energy_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-综合态势-能耗概括-编辑
export function wcZhEnergyEdit(data) {
  return request({
    url: "/wuchang/zhts_energy_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-综合态势-能耗概括-删除
export function wcZhEnergyDel(data) {
  return request({
    url: "/wuchang/zhts_energy_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-综合态势-能耗概括-详情
export function wcZhEnergyDetail(data) {
  return request({
    url: "/wuchang/zhts_energy_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-综合态势-能耗概括-列表
export function wcZhEnergyList(data) {
  return request({
    url: "/wuchang/zhts_energy_list",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 智慧运营
// 五常-智慧运营-活动展示-新增
export function wcYYActivityAdd(data) {
  return request({
    url: "/wuchang/zhyy_activity_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-智慧运营-活动展示-编辑
export function wcYYActivityEdit(data) {
  return request({
    url: "/wuchang/zhyy_activity_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-智慧运营-活动展示-删除
export function wcYYActivityDel(data) {
  return request({
    url: "/wuchang/zhyy_activity_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-智慧运营-活动展示-详情
export function wcYYActivityDetail(data) {
  return request({
    url: "/wuchang/zhyy_activity_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-智慧运营-活动展示-列表
export function wcYYActivityList(data) {
  return request({
    url: "/wuchang/zhyy_activity_list",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 五常-智慧运营-交流活动概况-编辑
export function wcYYSummarizeEdit(data) {
  return request({
    url: "/wuchang/exchange_summarize_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧运营-交流活动概况-详情
export function wcYYSummarizeDetail(data) {
  return request({
    url: "/wuchang/exchange_summarize",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 五常-智慧运营-运营成绩-编辑
export function wcYYPerformanceEdit(data) {
  return request({
    url: "/wuchang/operational_performance_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧运营-运营成绩-详情
export function wcYYPerformanceDetail(data) {
  return request({
    url: "/wuchang/get_operational_performance",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-园区党建-各项配置-编辑
export function wcYqdjConfigEdit(data) {
  return request({
    url: "/wuchang/yqdj_config_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-园区党建-各项配置-详情
export function wcYqdjConfigDetail(data) {
  return request({
    url: "/wuchang/yqdj_config_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 五常-数智管理-满意度调查-新增
export function wcSzglSatisfyAdd(data) {
  return request({
    url: "/wuchang/service_comment_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-数智管理-满意度调查-编辑
export function wcSzglSatisfyEdit(data) {
  return request({
    url: "/wuchang/service_comment_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-数智管理-满意度调查-删除
export function wcSzglSatisfyDel(data) {
  return request({
    url: "/wuchang/service_comment_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-数智管理-满意度调查-详情
export function wcSzglSatisfyDetail(data) {
  return request({
    url: "/wuchang/service_comment_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 五常-数智管理-满意度调查-分页列表
export function wcSzglSatisfyList(data) {
  return request({
    url: "/wuchang/service_comment_list",
    method: "post",
    data: Qs.stringify(data),
  });
}





// 五常-智慧经营-招商概括-编辑
export function wcJYInvestEdit(data) {
  return request({
    url: "/wuchang/zhjy_attract_investment_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧经营-招商概括-详情
export function wcJYInvestDetail(data) {
  return request({
    url: "/wuchang/zhjy_attract_investment",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 五常-智慧经营-园区营收年度目标-编辑
export function wcJYTargetEdit(data) {
  return request({
    url: "/wuchang/park_revenue_target_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧经营-园区营收年度目标-详情
export function wcJYTargetDetail(data) {
  return request({
    url: "/wuchang/park_revenue_target",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 五常-智慧经营-园区营收占比概括-编辑
export function wcJYRevenueEdit(data) {
  return request({
    url: "/wuchang/park_revenue_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧经营-园区营收占比概括-详情
export function wcJYRevenueDetail(data) {
  return request({
    url: "/wuchang/park_revenue_statistics",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 五常-智慧经营-园区营收占比概括-编辑
export function wcJYTaxEdit(data) {
  return request({
    url: "/wuchang/park_tax_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧经营-园区营收占比概括-详情
export function wcJYTaxDetail(data) {
  return request({
    url: "/wuchang/park_tax_statistics",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 五常-智慧经营-商业产业类型概括-编辑
export function wcJYIndustryEdit(data) {
  return request({
    url: "/wuchang/get_park_industry_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 五常-智慧经营-商业产业类型概括-详情
export function wcJYIndustryDetail(data) {
  return request({
    url: "/wuchang/get_park_industry",
    method: "post",
    data: Qs.stringify(data),
  });
}